var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webhook-automation-form" },
    [
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "field" },
          [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("automation.automationName")) + ": "),
            ]),
            _vm._v(" "),
            _c("a-input", {
              attrs: { placeholder: _vm.$t("automation.automationName") },
              model: {
                value: _vm.automationName,
                callback: function ($$v) {
                  _vm.automationName = $$v
                },
                expression: "automationName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "field" },
          [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("auto.webhookAutomationFormMethod")) + " "),
            ]),
            _vm._v(" "),
            _c("CustomPicker", {
              attrs: {
                items: _vm.methods,
                idKey: "id",
                labelKey: "label",
                title: _vm.$t("automation.selectMethod"),
              },
              model: {
                value: _vm.payload.method,
                callback: function ($$v) {
                  _vm.$set(_vm.payload, "method", $$v)
                },
                expression: "payload.method",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "field" },
          [
            _c("label", [_vm._v(_vm._s(_vm.$t("automation.bodyType")) + ": ")]),
            _vm._v(" "),
            _c("CustomPicker", {
              attrs: {
                items: _vm.bodyTypes,
                idKey: "id",
                labelKey: "label",
                title: _vm.$t("automation.selectBodyType"),
              },
              model: {
                value: _vm.payload.bodyType,
                callback: function ($$v) {
                  _vm.$set(_vm.payload, "bodyType", $$v)
                },
                expression: "payload.bodyType",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c("SupsisButton", { attrs: { primary: "" }, on: { click: _vm.save } }, [
        _vm._v(_vm._s(_vm.$t("message.save"))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }